import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { hotlineLpHeadStyle } from '@/feature/hotline/lp/component/HotlineLpHead/style';
/**
 * ホットライン LP 見出し
 */
export const HotlineLpHead = (props) => {
    const { className = '', mainText, subText, variants } = props;
    const style = hotlineLpHeadStyle(variants);
    return (_jsxs("hgroup", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx("p", Object.assign({ className: style.subText() }, { children: subText })), _jsx("h2", Object.assign({ className: style.mainText() }, { children: mainText }))] })));
};
